import * as React from 'react';
import { Link, navigate } from 'gatsby';
import PropTypes from 'prop-types';
import {
    KIRKOSWALD_ASSET_MANAGEMENT_LLC,
    KIRKOSWALD_GLOBAL_MANAGEMENT_SERVICES_LTD,
    KIRKOSWALD_CAPITAL_MANAGEMENT_LIMITED,
    KIRKOSWALD_CAPITAL_PARTNERS_LLP,
    KIRKOSWALD_GLOBAL_MANAGEMENT_SERVICES_MENA_LTD,
    KIRKOSWALD_ASSET_MANAGEMENT_ASIA_PTE_LTD,
    OFFICE_ADDRESSES
} from '../../constants/constants';
import * as style from './Footer.module.scss';

const resources = [
    {
        name: 'Terms of Use',
        to: '/terms-of-use/',
        local: true
    },
    {
        name: 'Privacy Policy',
        to: '/privacy-policy/',
        local: true
    },
    {
        name: 'California Consumer Privacy Policy',
        to: '/california-privacy-policy/',
        local: true
    },
    {
        name: 'SFDR Disclosures',
        to: '/sfdr-disclosures/',
        local: true
    },
    {
        name: 'TCFD Disclosures',
        to: '/tcfd-disclosures/',
        local: true
    },
    {
        name: 'Shareholder Rights Directive',
        to: '/shareholder-rights-directive/',
        local: true
    },
    {
        name: 'UK Stewardship Code',
        to: '/uk-stewardship-code/',
        local: true
    },
    {
        name: 'Modern Slavery Act',
        to: '/modern-slavery-act-2015-statement/',
        local: true
    }
];

const Links = () =>
    resources.map((resource, index) => {
        if (resource.local) {
            return (
                <Link key={index} className={style.links} to={resource.to}>
                    <span>{resource.name}</span>
                </Link>
            );
        }
        const target = resource.openInNewTab ? '_blank' : undefined;
        const rel = resource.openInNewTab ? 'noopener' : undefined;
        return (
            <a key={index} className={style.links} href={resource.to} rel={rel} target={target}>
                <span>{resource.name}</span>
            </a>
        );
    });

const formatAddress = office => (office?.lines || []).filter(Boolean).join(', ');

const Footer = ({ getInTouchVisible }) => {
    return (
        <footer id="site-footer">
            {getInTouchVisible && (
                <div className={style.contactWrapper}>
                    <h2 className={style.getInTouch}>
                        If you have any questions or would like to learn more about Kirkoswald, please get in touch.
                    </h2>
                    <a className={style.contactLink} href="/contact/">
                        CONTACT
                    </a>
                </div>
            )}
            <div className={style.footer}>
                <img
                    src="/kirkoswald/images/kirkoswald-logotype.png"
                    loading="lazy"
                    alt="Kirkoswald Logotype"
                    width="207"
                    onClick={() => navigate('/')}
                    className={style.footerLogo}
                />
                <div className={style.footerDisclaimer}>
                    <div className={style.footerLinks}>
                        <Links />
                    </div>
                    <br />
                    <p>
                        {KIRKOSWALD_CAPITAL_PARTNERS_LLP} is limited liability partnership incorporated in England and Wales with company
                        number OC387588.
                        <br />
                        Our office address is {formatAddress(OFFICE_ADDRESSES.londonSloaneStreet)}.
                        <br />
                        {KIRKOSWALD_CAPITAL_PARTNERS_LLP} is authorised and regulated by the Financial Conduct Authority (FRN 607529).
                    </p>
                    <br />
                    <p>
                        {KIRKOSWALD_CAPITAL_MANAGEMENT_LIMITED} is a limited company incorporated in England with company number 04916145.
                        <br />
                        Our office address is {formatAddress(OFFICE_ADDRESSES.londonParkStreet)}.
                        <br />
                        {KIRKOSWALD_CAPITAL_MANAGEMENT_LIMITED} is authorised and regulated by the Financial Conduct Authority (FRN 229812).
                    </p>
                    <br />
                    <p>
                        {KIRKOSWALD_ASSET_MANAGEMENT_LLC} is a limited liability company incorporated in The United States of America.
                        <br />
                        Our office address is {formatAddress(OFFICE_ADDRESSES.newYork)}.
                        <br />
                        {KIRKOSWALD_ASSET_MANAGEMENT_LLC} is a registered investment adviser with the U.S. Securities and Exchange Commission.
                    </p>
                    <br />
                    <p>
                        {KIRKOSWALD_GLOBAL_MANAGEMENT_SERVICES_LTD} is a corporation incorporated in the Commonwealth of the Bahamas.
                        <br />
                        Our office address is {formatAddress(OFFICE_ADDRESSES.bahamas)}.
                        <br />
                        {KIRKOSWALD_GLOBAL_MANAGEMENT_SERVICES_LTD} is registered with the Securities Commission of The Bahamas.
                    </p>
                    <br />
                    <p>
                        {KIRKOSWALD_ASSET_MANAGEMENT_ASIA_PTE_LTD} is a Private Limited Company incorporated in Singapore.
                        <br />
                        Our office address is {formatAddress(OFFICE_ADDRESSES.singapore)}.
                        <br />
                        {KIRKOSWALD_ASSET_MANAGEMENT_ASIA_PTE_LTD} is regulated by the Monetary Authority of Singapore and is the holder of a Capital Markets Services Licence.
                    </p>
                    <br />
                    <p>
                        {KIRKOSWALD_GLOBAL_MANAGEMENT_SERVICES_MENA_LTD} is a private company limited by shares incorporated in the Abu
                        Dhabi Global Market (ADGM).
                        <br />
                        Our office address is {formatAddress(OFFICE_ADDRESSES.abuDhabi)}.
                        <br />
                        {KIRKOSWALD_GLOBAL_MANAGEMENT_SERVICES_MENA_LTD} is registered with the ADGM under Commercial License Number 16148
                        and regulated by the ADGM Financial Services Regulatory Authority under Financial Services Permission Number 240063.
                    </p>
                    <br />
                </div>
            </div>
        </footer>
    );
};

Footer.propTypes = {
    getInTouchVisible: PropTypes.bool
};

Footer.defaultProps = {
    getInTouchVisible: true
};

export default Footer;
